// utils/buildPayload.js
import dayjs from "dayjs";
import { formatDateToDDMMYYYY } from "./dateFormat";

export const buildPersonalInfoPayload = (personal) => ({
  name: personal?.fullName,
  phone_number: personal?.mobile,
  email: personal?.email,
  dob: formatDateToDDMMYYYY(personal?.birthDate),
  gender: personal?.gender,
   ...(personal?.profileImage && { profile_img_url: personal?.profileImage }),
  addresses: [
    {
       ...(personal?.address_id && { id: personal?.address_id }),
      house_no: personal?.addressLine1,
      street_address: personal?.addressLine2,
      landmark: personal?.landmark,
      city: personal?.city,
      state: personal?.state,
      zipcode: personal?.zip,
      is_primary: true,
      latlong: {
      ...(personal?.latlong_id && { id: personal?.latlong_id }),
      latitude: personal?.latitude ? Number(personal?.latitude) : null,
      longitude: personal?.longitude ? Number(personal?.longitude) : null,
       is_deleted: false
       }
    }
  ],
privacy_policy_accepted: personal?.privacy_policy_accepted || true,
terms_and_conditions_accepted: personal?.terms_and_conditions_accepted || true
});

export const buildOtherDetailsPayload = ({ otherDetails = {}, uploadedDocs = [], id = "" }) => {
  return {
    deliveryPerson: {
      ...(id && { id: id }),
      vehicle_type: otherDetails?.vechicalType,
      vehicle_number: otherDetails?.licencePlateNumber,
      ...(uploadedDocs?.length > 0 && { uploadDoc: uploadedDocs }),
    }
  }
};

export const buildBankDetailsPayload = (bankDetails = {}, bank_id = "") => {
  const idFromForm = bankDetails?.id;
  const id =
    idFromForm != null && idFromForm !== ""
      ? idFromForm
      : bank_id != null && bank_id !== ""
        ? bank_id
        : undefined;

  return {
    bankDetails: [
      {
        ...(id != null && id !== "" ? { id } : {}),
        accountNumber: bankDetails?.accountNumber ?? "",
        accountName: bankDetails?.accountName ?? "",
        bankName: bankDetails?.bankName ?? "",
        routingNumber: bankDetails?.routingNumber ?? "",
      },
    ],
  };
};

// export const buildUploadDocsPayload = (uploadDocs) => ({
//   uploadDoc: uploadDocs ?? []
// });

export const buildServicesDetailsPayload = (servicesDetails) => {
     const payload = {
      serviceType: servicesDetails.serviceType
  }
   if (servicesDetails.unit === "pound") {
    payload.poundDetails = {
      quantity: Number(servicesDetails.lbs), 
      category: servicesDetails.category,
      price: Number(servicesDetails.price),
      cloth_name: servicesDetails.clothType,
      description: servicesDetails.description
    };
  }
    if (servicesDetails.unit === "piece") {
    payload.unitDetails = {
      serviceType: servicesDetails.serviceType,
      cloth_name: servicesDetails.clothType,
      category: servicesDetails.category,
      description: servicesDetails.description,
      price : Number(servicesDetails.price)
    };

    if (servicesDetails.serviceType === "TAILORING") {
      payload.unitDetails.tailoringType = {
        name: servicesDetails.tailoringType,
        price: Number(servicesDetails.price)
      };
    } 
    // else {
    //   payload.unitDetails.price = Number(servicesDetails.price);
    // }
  }
  return payload
};


export const buildStoreDetailsPayload = ({
  storeDetails = {},
  uploadedDocs = [],
  serviceDetails = [],
  store_id = "",
  address_id = "",
  latlong_id = ""
}) => {
  const formatTime = (val) => {
    if (val == null || val === "") return null;
    const d = dayjs(val);
    return d.isValid() ? d.format("hh:mm A") : null;
  };
  const formattedStoreHours = Object.entries(storeDetails?.storeHours || {}).reduce((acc, [day, value]) => {
    acc[day] = {
      open: formatTime(value.open),
      close: formatTime(value.close),
      note:value.note || ""
    };
    return acc;
  }, {});

  const hasStoreHours = Object.values(formattedStoreHours).some(val => val.open || val.close);
  return {
    stores: [
      {
        storeName: storeDetails.storeName,
        ...(store_id && { id: store_id }),
        ...(hasStoreHours && { store_hours: formattedStoreHours }),
        store_phone: storeDetails.storeContactNumber,
        licenceNumber: storeDetails.storeLicenseNumber,
        ...(uploadedDocs?.length > 0 && { uploadDoc: uploadedDocs }),
        ...(serviceDetails?.length > 0 && { services: serviceDetails }),
        storeAddresses: [
          {
            ...(address_id && { id: address_id }),
            house_no: storeDetails.addressLine1,
            street_address: storeDetails.addressLine2,
            landmark: storeDetails.landmark,
            city: storeDetails.city,
            state: storeDetails.state,
            zipcode: storeDetails.zip,
            is_primary: true,
            latlong: {
              ...(latlong_id && { id: latlong_id }),
              latitude: storeDetails.latitude ? Number(storeDetails.latitude) : null,
              longitude: storeDetails.longitude ? Number(storeDetails.longitude) : null,
              is_deleted: false
            }
          }
        ]
      }
    ]
  };
};

export const buildShortStorePayload = (storeDetails) => {
  
  return {
    stores: [
      {
        storeName: storeDetails.storeName,
        id: storeDetails?.store_id ,
        store_phone: storeDetails.storeContactNumber,
        licenceNumber: storeDetails.storeLicenseNumber,
        ...(storeDetails?.uploadedDocs?.length > 0 && { uploadDoc: storeDetails?.uploadedDocs }),
        storeAddresses: [
          {
            ...(storeDetails?.address_id && { id: storeDetails?.address_id }),
            house_no: storeDetails.addressLine1,
            street_address: storeDetails.addressLine2,
            landmark: storeDetails.landmark,
            city: storeDetails.city,
            state: storeDetails.state,
            zipcode: storeDetails.zip,
            is_primary: true,
            latlong: {
              ...(storeDetails?.latlong_id && { id: storeDetails?.latlong_id }),
              latitude: storeDetails.latitude ? Number(storeDetails.latitude) : null,
              longitude: storeDetails.longitude ? Number(storeDetails.longitude) : null,
              is_deleted: false
            }
          }
        ]
      }
    ]
  };
};
